import React, { useState } from 'react';
import { useI18n } from '../../i18n/LanguageContext';
import { useMedia } from '../../site/MediaProvider';
import FadeIn from './FadeIn';
import CountUp from './CountUp';
import { Factory } from 'lucide-react';

const About: React.FC = () => {
  const { t } = useI18n();
  const { single } = useMedia();
  const img = single('about');
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <section id="about">
      <div className="container">
        <div className="about-grid">
          <FadeIn variant="left">
            <span className="slabel sl-b">{t('about.badge')}</span>
            <h2 className="stitle">{t('about.title')}</h2>
            <p className="ssub">{t('about.text')}</p>
            <div className="stats-grid">
              <div className="stat-card"><span className="snum"><CountUp value={t('about.s1n')} /></span><span className="slbl">{t('about.s1')}</span></div>
              <div className="stat-card"><span className="snum"><CountUp value={t('about.s2n')} /></span><span className="slbl">{t('about.s2')}</span></div>
              <div className="stat-card"><span className="snum"><CountUp value={t('about.s3n')} /></span><span className="slbl">{t('about.s3')}</span></div>
              <div className="stat-card"><span className="snum"><CountUp value={t('about.s4n')} /></span><span className="slbl">{t('about.s4')}</span></div>
            </div>
          </FadeIn>
          <FadeIn variant="right" className="about-img-wrap" style={{ transitionDelay: '.15s' }}>
            <div className="img-wrap">
              {img && !imgFailed
                ? <img src={img} alt="RTS Facility" width={640} height={460} loading="lazy" decoding="async" onError={() => setImgFailed(true)} />
                : (
                  <div className="img-fallback" style={{ display: 'flex' }}>
                    <Factory size={64} color="rgba(255,255,255,.55)" aria-hidden />
                  </div>
                )}
            </div>
            <div className="about-pill">
              <Factory size={18} color="#fff" aria-hidden style={{ verticalAlign: '-3px', marginRight: 8 }} />
              <span dangerouslySetInnerHTML={{ __html: t('about.pill') }} />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default About;
